// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../.nvm/versions/node/v14.18.2/lib/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ol-map {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n}\n\n.ol-control {\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.4);\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.ol-full-screen {\n  top: 0.5em;\n  right: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
